const logError = (title: string, body: string): void => {
  console.error(`%c${title}`, `color: white; font-weight: bold; font-size: 1rem;`, body);
};

const isError = (value: unknown): value is Error => value instanceof Error;

export { logError, isError };
